import React from "react";
import { bool, string } from "prop-types";
import Link from "../Link";
import { classes } from "../utils/classes";
import Image from "../Image";

const LogoLink = ({ href = "/", external = true, imgSrc, alt = "", className = "", ...props }) => (
	<Link
		href={href}
		external={external}
		isBaseClassName={false}
		className={classes("logo-link", className)}
		{...props}
	>
		<Image src={imgSrc} className={classes("logo")} alt={alt} />
	</Link>
);

LogoLink.propTypes = {
	href: string,
	external: bool,
	imgSrc: string.isRequired,
	alt: string,
	className: string,
};

export default LogoLink;
